import { jsx as _jsx } from "react/jsx-runtime";
var StepCircle = function (_a) {
    var step = _a.step, complete = _a.complete, _b = _a.active, active = _b === void 0 ? false : _b;
    return (_jsx("div", { className: "mx-auto mb-2 flex h-9 w-9 items-center justify-center rounded-full text-sm font-bold text-white ".concat(complete ? "bg-sherpaFerner" : active ? "bg-primary" : "bg-sherpaCoffeeCream"), children: complete ? "✓" : step }));
};
export default StepCircle;
